<template>
      <el-form-item class="icon mb" :label="type+'图标设置'">
        <el-tooltip content="建议上传大小：135*135px" placement="top" class="tooltip">
            <span class="fa fa-question-circle"></span>
        </el-tooltip>
         <el-upload
          class="upload"
          :action="uploadUrl"
          :http-request="uploadFile"
          :before-upload="beforeAvatarUpload"
          :headers="headers"
          :show-file-list="false"
          name="image"
          :data="{type: 'SYSTEM'}">
          <div class="upload-click">
          <span class="update">  <i class="el-icon-plus "></i></span>
            <img v-if="model.appIcon" :src="getDownLoadUrl(model.appIcon)" alt="图片失效">
          </div>
          <div class="upload-btn">
          </div>
       </el-upload>
        <span class="choose-icon" @click="appearIcons" v-if="type==='流程'">选择图标</span>
        <div class="process-icons" v-if="iconVisiable" @mouseleave="iconVisiable=false">
          <span class="small-icon" :class="{'active':index===selectIndex}" v-for="(icon,index) in icons" :key="index" :title="icon.title" @click="selectIcon(index,icon.link)">
            <img :src="icon.link" :alt="icon.link" >
          </span>
        </div>
      </el-form-item>
</template>

<script>
import tokenStorage from '@/plugins/tokenStorage'
import {ossMixin} from '@/components/form/runtime/components/mixins'
export default {
  name: 'AppModel',
  props: ['model', 'type'],
  mixins: [ossMixin],
  data () {
    return {
      icons,
      headers: {'Authorization': tokenStorage.getToken()},
      selectIndex: -1,
      iconVisiable: false,
      uploadUrl: `${process.env.UPLOAD_URL}/api/upload-image`
    }
  },
  methods: {
    uploadFile (files) {
      let file = files.file
      let key = this.getOssKey('SYSTEM', file.name)
      let url = sessionStorage.getItem('ossDownloadUrl')
      let formData = this.getUploadFormData(key, file)
      this.$axios.post(url, formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(res => {
        if (res.status === 200) {
          this.successUpload(this.getResult(key, file.name), file)
        }
      })
    },
    beforeAvatarUpload (file) {
      let type = file.type
      let result = true
      if (type !== 'image/jpeg' && type !== 'image/png') {
        this.$message.error('上传头像图片只能是 jpg 或 png 格式!')
        result = false
      } else {
        if (file.size / 1024 / 1024 > 2) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
          result = false
        }
      }
      return result
    },
    // 上传成功，获取路径
    successUpload (res, file, fileList) {
      this.model.appIcon = res[0].result.dir
    },
    handleChange (files, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
    },
    appearIcons () {
      this.iconVisiable = true
    },
    selectIcon (index, link) {
      this.selectIndex = index
      this.model.appIcon = link
    },
    getDownLoadUrl (path) {
      //  return path.includes('USER') ? sessionStorage.getItem('downloadUrl') + path : path.includes('SYSTEM') ? sessionStorage.getItem('cdnDownloadUrl') + path : path
      return path.includes('base64') ? path : sessionStorage.getItem('ossDownloadUrl') + path
    }
  }
}
const icons = [
  {link: require('./icons/发票申请.png'), title: '发票申请'},
  {link: require('./icons/出差.png'), title: '出差'},
  {link: require('./icons/借款申请.png'), title: '借款申请'},
  {link: require('./icons/合同续签.png'), title: '合同续签'},
  {link: require('./icons/报备.png'), title: '报备'},
  {link: require('./icons/费用报销.png'), title: '费用报销'},
  {link: require('./icons/人事异动.png'), title: '人事异动'},
  {link: require('./icons/人员信息修改.png'), title: '人员信息修改'},
  {link: require('./icons/值班申请.png'), title: '值班申请'},
  {link: require('./icons/入职.png'), title: '入职'},
  {link: require('./icons/员工请假.png'), title: '员工请假'},
  {link: require('./icons/员工转正.png'), title: '员工转正'},
  {link: require('./icons/离职.png'), title: '离职'},
  {link: require('./icons/培训申请.png'), title: '培训申请'},
  {link: require('./icons/外出.png'), title: '外出'},
  {link: require('./icons/离职交接.png'), title: '离职交接'},
  {link: require('./icons/调休.png'), title: '调休'}
]
</script>
<style lang="scss" >
   .icon {
   position: relative;
   height: 33px;

   .tooltip {
     color: #c2c3c4;

     &:hover {
       color: #409EFF;
     }
   }

   .el-form-item__label {
     position: absolute;
     top: 10px;
   }

   .tooltip {
     position: absolute;
     left: 97px;
     top: 16px;

   }

   .upload {
     display: inline-block;
     position: absolute;
     left: 149px;
     top: -6px;
   }

   .upload-click {
     width: 56px;
     height: 56px;
     background: rgba(239, 247, 253, 1);
     position: relative;
     border-radius: 4px;
     overflow: hidden;

     &:hover {
       .update {
         display: block;
       }
     }

     .update {
       position: absolute;
       width: 56px;
       height: 56px;
       background: rgba(0, 0, 0, .6);
       text-align: center;
       line-height: 56px;
       display: none;

       i {
         color: #fff;
       }

     }

     img {
       height: 100%;
       width: 100%;

     }
   }

   .choose-icon {
     display: inline-block;
     position: absolute;
     left: 218px;
     top: 12px;
     width: 58px;
     height: 22px;
     line-height: 18px;
     text-align: center;
     color: #54ABF1;
     border: 1px solid #54ABF1;
     border-radius: 4px;
     font-size: 8px;
     display: inline-block;
     cursor: pointer;
   }

   .process-icons {
     width: 236px;
     height: 138px;
     background: #FFFFFF;
     box-shadow: 0px 0px 6px 0px #134987;
     border-radius: 4px;
     overflow: auto;
     padding: 14px 9px;
     position: absolute;
     right: -8px;
     top: -42px;

     .small-icon {
       display: inline-block;
       width: 38px;
       height: 38px;
       border: 1px solid transparent;
       padding: 2px;
       margin-right: 14px;
       cursor: pointer;

       &:nth-child(4n) {
         margin-right: 0;
       }

       &.active {
         border: 1px solid #54ABF1;
       }

       img {
         display: block;
         width: 100%;
         height: 100%;
       }
     }
   }
 }

</style>



// WEBPACK FOOTER //
// src/components/shared/openApp/app-model.vue